export function getSearchingGames(game, search_type_id) {
  if (!game.odd) {
    return "";
  }

  if (game.type_id == 1) {
    return `
            <li>
                <a class="moduleSportSingleLeagueMatchLink cursor-pointer w-auto flex flex-nowrap flex-row px-2 py-1 quickBetBetBtn normalMatch" quick-code="${game.game_code}" href="#/match/${game.id}">
                    <span class="flex text-[11px] leading-[20px] truncate whitespace-nowrap overflow-hidden text-ellipsis">${game.home_team}</span>
                    <span class="flex text-[11px] leading-[20px] justify-center truncate whitespace-nowrap overflow-hidden text-ellipsis">-</span>
                    <span class="flex text-[11px] leading-[20px] truncate whitespace-nowrap overflow-hidden text-ellipsis">${game.away_team}</span>
                </a>
            </li>
        `;
  } else {
    return `
            <li>
                <a class="moduleSportSingleLeagueMatchLink cursor-pointer w-auto flex flex-nowrap flex-row px-2 py-1" href="#/livematch/${game.id}">
                    <span class="flex text-[11px] leading-[20px] truncate whitespace-nowrap overflow-hidden text-ellipsis">${game.home_team}</span>
                    <span class="flex text-[11px] leading-[20px] justify-center truncate whitespace-nowrap overflow-hidden text-ellipsis">-</span>
                    <span class="flex text-[11px] leading-[20px] truncate whitespace-nowrap overflow-hidden text-ellipsis">${game.away_team}</span>
                </a>
            </li>
        `;
  }
}
